const SIZE_UNITS = ["B", "kB", "MB", "GB", "TB"]

export function formatArtifactSize(sizeBytes: number): string {
  if (!Number.isFinite(sizeBytes) || sizeBytes < 0) return ""
  let value = sizeBytes
  let unitIndex = 0
  while (value >= 1000 && unitIndex < SIZE_UNITS.length - 1) {
    value /= 1000
    unitIndex += 1
  }
  let decimals = unitIndex === 0 || value >= 10 ? 0 : 1
  if (Number(value.toFixed(decimals)) >= 1000 && unitIndex < SIZE_UNITS.length - 1) {
    value /= 1000
    unitIndex += 1
    decimals = value >= 10 ? 0 : 1
  }
  return `${value.toFixed(decimals)} ${SIZE_UNITS[unitIndex]}`
}
